module.exports = __webpack_public_path__ + "static/img/qrcode_2.4aae286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode_2.png
// module id = sFTw
// module chunks = 30